import { InternalSliceData } from '../types/internal/pie-chart.js';

/**
 * Calculates what's the percentage of a value in relation to a total.
 * @param value - The value that will be used to calculate it's percentage.
 * @param totalValue - The total value that would correspond to a 100%.
 * @returns The value in percentage format of the supplied flat value.
 */
export const getSlicePercentage = (
  sliceValue: number,
  allSlicesValue: number,
): number => +(Math.abs(sliceValue * 100) / allSlicesValue);

/**
 * Calculates the relative value of each slice in %.
 * @param slices - Array of an internal slice data
 * @returns - Same sorted object with its relative value property.
 */
export const getSlicesWithRelativeValues = (
  slices: InternalSliceData[],
): InternalSliceData[] => {
  const totalAbsoluteValueSum = Object.values(slices).reduce(
    (total, { value }) => total + Math.abs(value),
    0,
  );

  return slices.map((data) => ({
    ...data,
    relativeValue: getSlicePercentage(data.value, totalAbsoluteValueSum),
  }));
};
